<template>
  <div class="lottery-page">
    <!-- 顶部标题 -->
    <div class="header">{{ $t('lottery.title') }}</div>
    <!-- 热门标签 -->
    <div class="hot-tag">{{ $t('lottery.hot_tag') }}</div>
    <!-- 卡片网格 -->
    <div class="card-grid">
      <div
        class="card-item"
        v-for="(item, index) in gameList"
        :key="item.id || index"
        @click="goToDetail(item)"
      >
        <div class="card-thumb">
          <img :src="item.ico || '/img/neww/video.png'" />
        </div>
        <div class="card-info">
          <div class="card-name">{{ item.name }}</div>
          <div class="card-count">{{ $t('lottery.all_day_boost') }}: 480 </div>
          <div class="card-time">{{ getCountdown(item.id) }}</div>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div class="nav-item" @click="goToPage('Home')">
        <img class="nav-icon" :src="currentPage === 'Home' ? '/img/footer/indexed.png' : '/img/footer/index.png'" />
        <span class="nav-text" :class="{ active: currentPage === 'Home' }">{{ $t('my.home') }}</span>
      </div>
      <div class="nav-item" @click="goToPage('Movie')">
        <img class="nav-icon" :src="currentPage === 'Movie' ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'" />
        <span class="nav-text" :class="{ active: currentPage === 'Movie' }">{{ $t('my.video_zone') }}</span>
      </div>
      <div class="nav-item" @click="goToPage('Mine')">
        <img class="nav-icon" :src="currentPage === 'Mine' ? '/img/footer/myed.png' : '/img/footer/my.png'" />
        <span class="nav-text" :class="{ active: currentPage === 'Mine' }">{{ $t('my.personal_center') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 'Movie',
      gameList: [],
      countdownMap: {},
      countdownTimer: null
    };
  },
  methods: {
    formatTime(second) {
      const s = parseInt(second) || 0;
      const h = String(Math.floor(s / 3600)).padStart(2, '0');
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const sec = String(s % 60).padStart(2, '0');
      return h + ':' + m + ':' + sec;
    },
    getCountdown(id) {
      return this.formatTime(this.countdownMap[id] || 0);
    },
    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownMap = {};
      // 逐個從後端獲取倒計時（與lottery.vue一致，使用服務器時間）
      const promises = this.gameList.map((item) => {
        return this.$http({
          method: 'get',
          url: 'lottery_get_info',
          data: { key: item.key }
        }).then((res) => {
          if (res.code === 200 && res.data) {
            this.$set(this.countdownMap, item.id, res.data.second || 0);
          }
        }).catch(() => {});
      });
      Promise.all(promises).then(() => {
        // 所有倒計時獲取完成後開始倒計時
        this.countdownTimer = setInterval(() => {
          let needUpdate = false;
          this.gameList.forEach((item) => {
            if (this.countdownMap[item.id] > 0) {
              this.countdownMap[item.id]--;
              needUpdate = true;
            } else {
              // 倒計時結束，重新從後端獲取最新倒計時
              this.refreshCountdown(item);
            }
          });
          if (!needUpdate) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
        }, 1000);
      });
    },
    refreshCountdown(item) {
      this.$http({
        method: 'get',
        url: 'lottery_get_info',
        data: { key: item.key }
      }).then((res) => {
        if (res.code === 200 && res.data) {
          this.$set(this.countdownMap, item.id, res.data.second || 0);
        }
      }).catch(() => {});
    },
    goToDetail(item) {
      this.$router.push({
        path: '/LotteryDetail',
        query: { id: item.id, key: item.key }
      });
    },
    goToPage(page) {
      this.currentPage = page;
      if (page === 'Home') {
        this.$router.push({ path: '/Home' });
      } else if (page === 'Mine') {
        this.$router.push({ path: '/Mine' });
      }
    },
    getGameList() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then((res) => {
        this.gameList = res.data || [];
        this.startCountdown();
      });
    }
  },
  created() {
    this.getGameList();
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.dataTimer) {
      clearInterval(this.dataTimer);
    }
  }
};
</script>

<style lang="less" scoped>
.lottery-page {
  min-height: 100vh;
  background: #151515;
  color: #fff;
  padding-bottom: 60px;
  box-sizing: border-box;
}

.header {
  text-align: center;
  padding: 14px 0;
  margin-bottom: 30px;
  color: #22cc61;
  font-size: 26px;
  font-weight: 700;
  background: #151515;
}

.hot-tag {
  background: #22cc61;
  color: #fff;
  text-align: center;
  padding: 20px 0;
  font-size: 26px;
  font-weight: 700;
}

.card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 12px;
}

.card-item {
  width: 50vw;
  background: #2b2b2b;
  border-radius: 30px;
  padding: 12px;
  display: flex;
  align-items: center;
  border: 1px solid #2a2a2a;
}

.card-thumb {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 10px;
}

.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-info {
  flex: 1;
  overflow: hidden;
}

.card-name {
  color: #22cc61;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-count {
  color: #22cc61;
  font-size: 28px;
  margin-bottom: 4px;
}

.card-time {
  color: #22cc61;
  font-size: 28px;
  font-variant-numeric: tabular-nums;
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 55px;
  background: #151515;
  border-top: 1px solid #222;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.nav-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 2px;
}

.nav-text {
  color: #666;
  font-size: 11px;
}

.nav-text.active {
  color: #22cc61;
}
</style>
